import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import {
  Colors,
  ColorsType,
  FontSize,
  FontWeight,
  LineHeight,
} from '@common/tokens';

type Props = {
  size?: 'sm' | 'md' | 'lg';
  weight?: 'light' | 'medium' | 'bold';
  color?: ColorsType;
  center?: boolean;
  className?: string;
};

export function Paragraph({
  size = 'md',
  weight = 'light',
  color = 'textDefault',
  center = false,
  className,
  children,
}: PropsWithChildren<Props>) {
  const colorHash = Colors[color];

  return (
    <>
      <p
        className={clsx(
          className,
          `wk-paragraph wk-paragraph-size--${size} wk-paragraph-weight--${weight}`,
          {
            'wk-paragraph--center': center,
          }
        )}
      >
        {children}
      </p>
      <style jsx>{`
        .wk-paragraph {
          color: ${colorHash};
          margin: 0;
        }

        .wk-paragraph--center {
          text-align: center;
        }

        .wk-paragraph-weight--light {
          font-weight: ${FontWeight.light};
        }
        .wk-paragraph-weight--medium {
          font-weight: ${FontWeight.medium};
        }
        .wk-paragraph-weight--bold {
          font-weight: ${FontWeight.bold};
        }

        .wk-paragraph-size--sm {
          font-size: ${FontSize.xs};
        }
        .wk-paragraph-size--md {
          font-size: ${FontSize.sm};
        }
        .wk-paragraph-size--lg {
          font-size: ${FontSize.md};
        }

        p.wk-paragraph + p.wk-paragraph-size--sm {
          margin-top: 20px;
        }
        p.wk-paragraph + p.wk-paragraph-size--md {
          margin-top: 24px;
        }
        p.wk-paragraph + p.wk-paragraph-size--lg {
          margin-top: 28px;
        }

        p.wk-paragraph-size--sm {
          line-height: ${LineHeight.sm};
        }
        p.wk-paragraph-size--md {
          line-height: ${LineHeight.lg};
        }
        p.wk-paragraph-size--lg {
          line-height: ${LineHeight.xl};
        }
      `}</style>
    </>
  );
}
